import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService, IntermodalService, SwalService } from '@core/services';
import { AwsService, TranslateService } from '__services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-entry-additional',
  templateUrl: './entry-additional.component.html',
  styleUrls: ['./entry-additional.component.scss']
})
export class EntryAdditionalComponent implements OnInit, OnDestroy {
  @Input() set detail(value) {
    if (value) {
      console.log(value);

      this.documentDetail = value;
      this.eID = value.eId
    }
  };
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>()
  @Output() saveSuccess: EventEmitter<any> = new EventEmitter<any>()
  addFileForm: FormGroup;
  saving: boolean = false;
  private destroy$: Subject<any> = new Subject();
  documentDetail;
  eID;

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private intermodalService: IntermodalService,
    private translationService: TranslateService,
    private awsService: AwsService
  ) { }

  ngOnInit(): void {
    this.initAddFileForm();
  }

  initAddFileForm() {
    this.addFileForm = this.fb.group({
      file: [null, Validators.required],
      reason: [null, Validators.required]
    })
  }

  onCancel() {
    this.cancel.emit();
  }

  onSave() {
    if(this.addFileForm.invalid) {
      return
    }
    this.saving = true
    const {file, reason} = this.addFileForm.value;
    this.awsService.uploadFileEncryption(
      'entry/documents',
      file,
    ).then((res: any) => {
      const obj = {
        uri: res.key,
        reason,
      }
      this.updateDocumentById(obj)
    }).catch(err => {
      this.saving = false;
      SwalService.warning(err?.message);
    });
  }

  updateDocumentById(obj): void {
    const data = {
      documents: [obj]
    }
    this.intermodalService.updateValidateEntryById(this.documentDetail.id, this.eID, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          SwalService.success(
            this.translationService.translate('Updated the document successfull')
          ).then(() => {
            this.saveSuccess.emit(
              {
                s3_key: obj.uri,
                name: obj.uri.split('/').slice(-1)[0],
                added_reason: obj.reason
              }
            );
          });
        },
        (err) => {
          SwalService.warning(err.message);
        }
      ).add(() => this.saving = false);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
